__turbopack_context__.v({
  "__btn": "ckOc9G___btn",
  "__btnIsActive": "ckOc9G___btnIsActive",
  "__item": "ckOc9G___item",
  "collection": "ckOc9G_collection",
  "content": "ckOc9G_content",
  "selectContainer": "ckOc9G_selectContainer",
});
